






























































import Vue from 'vue'
import Component from 'vue-class-component'
import { AuthState, AuthStateData } from '@/services/UserManager'
import { Subscription } from 'rxjs'
import appManager from '@/services/AppManager'
import { isValidEmail } from '@/core/Utils'
import { FirebaseError } from 'firebase'
import { FirebaseAuthErrorCodes } from '@/extern/FirebaseTypes'
import FormTextField from '@/components/FormTextField.vue'
import { RoutePaths } from '@/router'

@Component({
    components: {
        FormTextField
    }
})
export default class LoginPanel extends Vue {
    state: AuthStateData|null = null
    email: string|null = null
    password: string|null = null
    emailErrorMessage: string|null = null
    passwordErrorMessage: string|null = null
    loginErrorMessage = ''
    stateSubscription: Subscription|undefined
    forgotPasswordEmail: string|null = null
    isForgotPasswordDialogVisible = false
    isSendingPasswordResetEmail = false

    // noinspection JSUnusedGlobalSymbols
    created() {
        this.stateSubscription = appManager.userManager.stateStream.subscribe(state =>
            this.onAuthStateChanged(state)
        )
    }

    // noinspection JSUnusedGlobalSymbols
    destroyed() {
        if (this.stateSubscription)
            this.stateSubscription.unsubscribe()
    }

    isLoggingIn(): boolean {
        return this.state?.state === AuthState.LOGGING_IN
    }

    private onAuthStateChanged(state: AuthStateData) {
        console.log(`Auth State: ${state?.state}`)
        this.state = state
    }

    async onLogInPressed() {
        const email = this.email?.trim()
        const password = this.password
        if (!email)
            this.emailErrorMessage = 'Must specify an email'
        else if (!isValidEmail(email))
            this.emailErrorMessage = 'Invalid email format'
        else
            this.emailErrorMessage = null
        this.passwordErrorMessage = password ? null : 'Must specify a password'

        if (email && password && !this.emailErrorMessage && !this.passwordErrorMessage) {
            try {
                await appManager.userManager.signIn(email, password)

                // NOTE: commented out replacing the path so that users will not be
                //       redirected if they chose a specific url
                // await this.$router.replace(RoutePaths.PORTAL_HOME)
            } catch (error: any) {
                const firebaseError = error as FirebaseError
                if (firebaseError.code === FirebaseAuthErrorCodes.INVALID_EMAIL ||
                    firebaseError.code === FirebaseAuthErrorCodes.USER_NOT_FOUND ||
                    firebaseError.code === FirebaseAuthErrorCodes.WRONG_PASSWORD) {
                    this.loginErrorMessage = 'Invalid email or password'
                } else {
                    this.loginErrorMessage = error.message || 'Invalid email or password'
                }
            }
        }
    }

    onForgotPasswordPressed() {
        // start with the currently entered email if the user has entered one
        this.forgotPasswordEmail = this.email?.trim() || null
        this.isForgotPasswordDialogVisible = true
        this.isSendingPasswordResetEmail = false
    }

    async onSendPasswordResetEmailPressed() {
        const email = this.forgotPasswordEmail?.trim()
        if (!email) {
            return
        }

        this.isSendingPasswordResetEmail = true

        let showSentMessage = false

        try {
            await appManager.userManager.sendPasswordResetEmail(email)

            showSentMessage = true
        } catch (error: any) {
            let message: string|undefined
            const firebaseError = error as FirebaseError
            if (firebaseError.code === FirebaseAuthErrorCodes.INVALID_EMAIL) {
                message = 'Please enter a valid email'
            } else if (firebaseError.code === FirebaseAuthErrorCodes.USER_NOT_FOUND) {
                // for security reasons do not show an error message if the user was not found
                showSentMessage = true
            } else {
                message = 'Error sending password reset email'
            }

            if (message)
                appManager.alertManager.publishError(message)
        }

        this.isSendingPasswordResetEmail = false

        if (showSentMessage) {
            this.isForgotPasswordDialogVisible = false
            appManager.alertManager.publishSuccess('A reset link will be sent if the email is valid. ' +
                'Please check your spam folder if not seen.')
        }
    }
}
